module.exports = __webpack_public_path__ + "static/media/imagem-relogio.f0062182.png";